import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/design-system/components/Button/Button.tsx';
import { ArrowRight } from '@phosphor-icons/react';
import { useCallback } from 'react';
import type { OpenXAgentTool, OpenXAgentToolConfig } from './utils/types.ts';

type OpenXAgentFeatureCardProps = {
  tool: OpenXAgentToolConfig;
  onSelectTool: (toolId: OpenXAgentTool) => void;
};

export const OpenXAgentFeatureCard = ({ tool, onSelectTool }: OpenXAgentFeatureCardProps) => {
  const { id, title, description, cta } = tool;
  const handleClick = useCallback(() => onSelectTool(id), [onSelectTool, id]);

  return (
    <Box
      component="article"
      aria-labelledby={`openx-agent-tool-${id}-title`}
      data-test={`openx-agent-feature-card-${id}`}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        px: 3,
        py: 2,
        border: '1px solid',
        borderRadius: '8px',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          id={`openx-agent-tool-${id}-title`}
          variant="h3"
          sx={{ m: 0, fontSize: 16, lineHeight: '22px', fontWeight: 'fontWeightMedium', color: 'text.primary' }}
        >
          {title}
        </Typography>
      </Box>

      <Typography sx={{ mt: 1, fontSize: 14, lineHeight: '20px', color: 'text.secondary' }}>{description}</Typography>

      <Button variant="text" size="medium" endIcon={<ArrowRight />} sx={{ mt: 1 }}>
        {cta}
      </Button>
    </Box>
  );
};
